export default "__VITE_ASSET__D4d05t2r__"